<template>
  <path d="M112,512.21C112,291,291,112,512.13,112,733,112,912,291.17,912,512.05c0,221.13-179.31,400.23-400.38,400C290.72,911.72,112,732.93,112,512.21ZM518.36,696.52c14.67,0,29.34,0,44,0,47.74-.17,95.39-1.81,142.93-6.54,32.38-3.23,56.22-23,62.49-54.45a379.75,379.75,0,0,0,7.32-55.41c1.53-31.21,1.67-62.5,1.65-93.76,0-32.62-1.61-65.15-8.49-97.22-6.37-29.67-28-51.29-58.2-54.24-34.33-3.36-68.82-5.64-103.3-6.64-43.54-1.26-87.13-1-130.69-.93-52.76.09-105.48,1.41-158,6.72-31.46,3.18-55.49,23.11-61.77,54.2A374.13,374.13,0,0,0,249,442.75c-1.57,29.87-1.73,59.83-1.78,89.76-.06,34.39,1.31,68.73,8.63,102.55,6.47,29.9,28.37,51,58.79,54.17,27.53,2.87,55.21,4.93,82.87,5.88C437.74,696.5,518.36,696.75,518.36,696.52Z"/><path d="M430,611.88V409.64L622.8,510.75Z"/>
</template>

<script>
export default {
  name: "IconYoutube"
}
</script>
